import React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";

@observer
export default class Container extends React.Component {
  @observable styles = {};
  @observable dragging = false;
  @observable cursor = "default";
  @observable zoom = 1;
  keys = [];
  mouseX = 0;
  mouseY = 0;
  eventHandlers = [];
  intervals = [];
  @observable style = {};
  zoomAmount = 0.04;
  frozen = false;
  canTrigger = true;

  constructor(props) {
    super(props);

    this.state = {
      width:
        this.props.width || (this.props.className ? "none" : window.innerWidth),
      height:
        this.props.height ||
        (this.props.className ? "none" : window.innerHeight)
    };

    this.events = this.props.events || false;
    this.zoom = this.props.zoom || 1;
    // this.minZoom = this.props.minZoom || 0.3;
    this.maxZoom = this.props.maxZoom || 2;
    this.lastCursor = this.cursor;
  }

  on(event, handler) {
    if (!this.eventHandlers[event]) this.eventHandlers[event] = [];
    this.eventHandlers[event].push(handler);
  }

  callEvent(event, ...args) {
    if (this.eventHandlers[event]) {
      this.eventHandlers[event].forEach(handler => handler(...args));
    }
  }

  componentDidMount() {
    this.container = this.refs.container;
    this.contentWrapper = this.refs.contentWrapper;
    this.content = this.refs.content;
    this.bounds = this.container.getBoundingClientRect();
    if (this.events) {
      this.registerEvents();
      this.updateScrollbars();
      this.container.scrollLeft =
        (this.container.scrollWidth - this.container.clientWidth) / 2;
      this.container.scrollTop =
        (this.container.scrollHeight - this.container.clientHeight) / 2;
    }

    // const contWidth = parseFloat(window.getComputedStyle(this.container).width)
    // this.minZoom = contWidth / this.props.innerWidth - 0.01;
  }

  getChild(index) {
    return this.refs["child-" + index];
  }

  registerEvents() {
    const container = this.container;
    container.addEventListener("mousedown", this.onMouseDown.bind(this));
    container.addEventListener("mousemove", this.onMouseMove.bind(this));
    container.addEventListener("mouseup", this.onMouseUp.bind(this));
    // container.addEventListener('mouseout', this.onMouseUp.bind(this));
    container.addEventListener("mousewheel", this.onMouseWheel.bind(this));
    window.addEventListener("keydown", this.onKeyDown.bind(this));
    window.addEventListener("keyup", this.onKeyUp.bind(this));
  }

  onKeyDown(e) {
    if (e.key === "Alt") e.preventDefault();
    this.keys[e.key] = {
      down: true
    };
    this.doTriggerZoomOrigin();
  }

  doTriggerZoomOrigin() {
    if (this.getInput("Control") && this.canTrigger) {
      this.triggerZoomOrigin(this.mouseX, this.mouseY);
      this.canTrigger = false;
    }
  }

  onKeyUp(e) {
    const key = e.key;
    if (this.keys[key] && this.keys[key].down) {
      this.keys[key] = { down: false };
    }
  }

  getInput(key) {
    return this.keys[key] && this.keys[key].down;
  }

  onMouseWheel(e) {
    if (this.keys["Control"] && this.keys["Control"].down) {
      e.preventDefault();
      e.stopPropagation();

      const amount = this.zoomAmount;

      const dir = e.deltaY < 0 ? 1 : -1;
      const currentZoom = this.zoom;

      const newZoom = currentZoom + amount * dir;
      this.zoomTo(newZoom);
    }
  }

  updateScrollbars() {
    const cw = this.contentWrapper;
    const newWidth = this.props.innerWidth * this.zoom;
    const newHeight = this.props.innerHeight * this.zoom;
    cw.style.width = newWidth + "px";
    cw.style.height = newHeight + "px";
  }

  defaultZoom() {
    const container = this.container;
    this.zoom = 0.5;
    this.updateScrollbars();
    setTimeout(() => {
      container.scrollLeft =
        (container.scrollWidth - container.clientWidth) / 2;
      container.scrollTop =
        (container.scrollHeight - container.clientHeight) / 2;
    }, 0);
  }

  zoomIn() {
    // console.log(this.mouseX, this.mouseY);
    this.triggerZoomOrigin(this.mouseX, this.mouseY);
    const newZoom = this.zoom + 0.1 * this.zoom;
    this.zoomTo(newZoom);
  }

  zoomOut() {
    this.triggerZoomOrigin(this.mouseX, this.mouseY);
    this.zoomTo(this.zoom - 0.1 * this.zoom);
  }

  zoomOutArea(area) {
    const newZoom = this.zoom - 0.5 * this.zoom;
    this.zoomAreaToCenter(area, newZoom);
  }

  zoomInArea(area) {
    let { w, h } = area;

    let workspaceWidth = this.container.clientWidth;
    let workspaceHeight = this.container.clientHeight;

    const ratio = Math.min( workspaceWidth  / w, workspaceHeight / h);
    const newZoom = this.zoom * ratio;

    this.zoomAreaToCenter(area, newZoom);
  }

  zoomOutFromCenter() {
    const midX = this.bounds.x + this.container.clientWidth / 2;
    const midY = this.bounds.y + this.container.clientHeight / 2;

    this.frozen = false;
    this.zoomTo(
      0.92 * this.zoom,
      {
        x: midX,
        y: midY
      },
      {
        x: midX,
        y: midY
      }
    );
  }

  zoomInToCenter() {
    const midX = this.bounds.x + this.container.clientWidth / 2;
    const midY = this.bounds.y + this.container.clientHeight / 2;

    this.frozen = false;
    this.zoomTo(
      1.08 * this.zoom,
      {
        x: midX,
        y: midY
      },
      {
        x: midX,
        y: midY
      }
    );
  }

  zoomToCenter(zoom) {
    const midX = this.bounds.x + this.container.clientWidth / 2;
    const midY = this.bounds.y + this.container.clientHeight / 2;

    this.frozen = false;
    this.zoomTo(
      zoom,
      {
        x: midX,
        y: midY
      },
      {
        x: midX,
        y: midY
      }
    );
  }

  zoomAreaToCenter(area, newZoom) {
    let { x, y, w, h } = area;
    x = x - this.bounds.x;
    y = y - this.bounds.y;

    const SelectionCenter = {
      x: x + w / 2,
      y: y + h / 2
    };

    const ScreenCenter = {
      x: this.container.clientWidth / 2,
      y: this.container.clientHeight / 2
    };

    this.frozen = false;
    this.zoomTo(
      newZoom,
      {
        x: SelectionCenter.x,
        y: SelectionCenter.y
      },
      {
        x: ScreenCenter.x,
        y: ScreenCenter.y
      }
    );
  }

  zoomTo(value, origin, to) {
    const canScrollX = this.haveScroll("x");
    const dir = value > this.zoom ? 1 : -1;

    if (!canScrollX && dir === -1) return;
    if (value > this.maxZoom && (!origin || !to) && dir !== -1) return;

    let correctZoom;
    if (!origin && !to)
      correctZoom =
        value < this.minZoom
          ? this.minZoom
          : value > this.maxZoom
            ? this.maxZoom
            : value;
    else correctZoom = value;

    if ((origin || this.zoomOrigin) && !this.frozen) {
      let oX = (origin && origin.x) || this.zoomOrigin.x - this.bounds.x;
      let oY = (origin && origin.y) || this.zoomOrigin.y - this.bounds.y;
      let point = this.pointOnCanvas(oX, oY);
      this.pointToZoom = {
        x: point.x / this.zoom,
        y: point.y / this.zoom
      };
      this.frozen = true;
    }

    this.zoom = correctZoom;
    this.updateScrollbars();

    if (this.pointToZoom)
      if (to)
        this.canvasPointToMouseCursor(
          this.pointToZoom.x,
          this.pointToZoom.y,
          to.x,
          to.y
        );
      else
        this.canvasPointToMouseCursor(this.pointToZoom.x, this.pointToZoom.y);

    this.callEvent("zoomChange", this.zoom);
  }

  canvasPointToMouseCursor(x, y, mx, my) {
    x = x * this.zoom;
    y = y * this.zoom;
    const container = this.container;
    let nX = mx || this.mouseX - this.bounds.x;
    let nY = my || this.mouseY - this.bounds.y;
    let CanvasMousePoint = this.pointOnCanvas(nX, nY);

    // console.log(CanvasMousePoint.x, x);

    const deltaX = CanvasMousePoint.x - x;
    const deltaY = CanvasMousePoint.y - y;

    container.scrollLeft -= deltaX;
    container.scrollTop -= deltaY;
  }

  pointOnCanvas(x, y) {
    const container = this.container;
    return {
      x: container.scrollLeft + x,
      y: container.scrollTop + y
    };
  }

  onMouseDown(e) {
    if (e.button === 1) {
      e.preventDefault();
      e.stopPropagation();

      this.setCursor("grabbing");

      this.dragStart = {
        x: e.clientX,
        y: e.clientY,
        scrollLeft: this.container.scrollLeft,
        scrollTop: this.container.scrollTop
      };
      this.dragging = true;
    }
  }

  haveScroll(axis) {
    switch (axis) {
      case "x":
        return this.container.scrollWidth > this.container.offsetWidth;

      case "y":
        return this.container.scrollHeight > this.container.offsetHeight;

      default:
        return false;
    }
  }

  onMouseMove(e) {
    this.mouseX = e.clientX;
    this.mouseY = e.clientY;
    const precision = 1;
    const x = e.clientX;
    const y = e.clientY;
    this.canTrigger = true;
    if (this.dragging) {
      const deltaX = x - this.dragStart.x;
      const deltaY = y - this.dragStart.y;

      const container = this.container;

      if (this.haveScroll("x")) {
        container.scrollLeft = this.dragStart.scrollLeft - deltaX / precision;
        this.prevLeft = container.scrollLeft;
      }
      if (this.haveScroll("y"))
        container.scrollTop = this.dragStart.scrollTop - deltaY / precision;
    } else {
      if (this.getInput("Control")) {
        this.triggerZoomOrigin(x, y);
      }
    }
  }

  triggerZoomOrigin(x, y) {
    this.zoomOrigin = {
      x,
      y
    };
    this.frozen = false;
  }

  onMouseUp(e) {
    if (this.dragging) {
      // console.log(this.mouseX, this.zoomOrigin.x)
      this.restoreLastCursor();
      this.dragging = false;
    }
  }

  registerChilds() {
    this.childs = [];
    React.Children.map(this.props.children, (child, index) => {
      const childClone = React.cloneElement(child, {
        parent: this,
        key: index,
        index: index,
        ref: "child-" + index
      });
      this.childs.push(childClone);
    });
    this.activeChilds = [...this.childs];
  }

  removeChild(child) {
    // update all the childs
    let e = this.activeChilds.find(el => {
      return el.props.index === child.props.index;
    });
    const index = this.activeChilds.indexOf(e);
    if (index !== -1) {
      this.activeChilds.splice(index, 1);
      this.forceUpdate();
    }
  }

  updateChild(index, child) {
    const old = this.activeChilds[index];
    if (old) {
      const newProps = {};
      Object.keys(child.state).forEach(key => {
        newProps[key] = child.state[key];
      });
      const cloned = React.cloneElement(old, newProps);
      this.activeChilds[index] = cloned;
    }
  }

  showChild(child) {
    let e = this.childs.find(el => {
      return el.props.index === child.props.index;
    });
    if (e) {
      const childClone = React.cloneElement(e, {
        parent: this,
        key: e.key,
        position: child.state.position
      });
      this.activeChilds.push(childClone);
      this.forceUpdate();
    }
  }

  addChild(child) {
    this.activeChilds.push(child);
    this.forceUpdate();
  }

  getChilds() {
    if (this.activeChilds)
      return [...this.activeChilds, this.getScaledToolActions()];
    else {
      this.childs = [];
      React.Children.map(this.props.children, (child, index) => {
        if (!child) return;
        const childClone = React.cloneElement(child, {
          parent: this,
          key: index,
          index: index,
          ref: "child-" + index
        });
        this.childs.push(childClone);
      });
      this.activeChilds = [...this.childs];
      return this.activeChilds;
    }
  }

  childsToComponents() {
    const array = [];
    for (let i = 0; i < this.activeChilds.length; i++) {
      const index = this.activeChilds[i].props.index;
      const component = this.refs["child-" + index];
      array.push(component);
    }
    return array;
  }

  restoreLastCursor() {
    this.setCursor(this.lastCursor);
  }

  setCursor(cursor) {
    this.lastCursor = this.cursor;
    this.cursor = cursor;
  }

  getStyles() {
    return {
      ...(this.props.style || {}),
      ...{
        width: this.state.width,
        height: this.state.height,
        boxSizing: "border-box"
      },
      ...(this.events ? { cursor: this.cursor } : {})
    };
  }

  getActualContainer() {
    return this.container;
  }

  setToolBar(toolbar) {
    this.toolbar = toolbar;
  }

  getToolActions() {
    if (!this.toolbar) return null;
    return Object.keys(this.toolbar.tools).map((key, index) => {
      const tool = this.toolbar.getToolComponent(key);
      return tool.renderAction ? tool.renderAction(index) : null;
    });
  }

  getScaledToolActions() {
    if (!this.toolbar) return null;
    return Object.keys(this.toolbar.tools).map((key, index) => {
      const tool = this.toolbar.getToolComponent(key);
      return tool.renderScaledAction ? tool.renderScaledAction(index) : null;
    });
  }

  render() {
    const childs = this.getChilds();
    return (
      <div
        className={
          "Container" + (this.props.className ? " " + this.props.className : "")
        }
        style={this.getStyles()}
        ref="container"
      >
        <div ref="contentWrapper">
          <div
            className="zoomarea"
            ref="content"
            style={{
              ...(this.events
                ? {
                    transformOrigin: "left top",
                    transform: "scale(" + this.zoom + ")"
                  }
                : {}),
              ...{
                width: this.props.innerWidth || 2 * this.state.width,
                height: this.props.innerHeight || 2 * this.state.height,
                position: "relative"
              }
            }}
          >
            {childs}
          </div>
        </div>
        {this.getToolActions()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/windows/Container.js